var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.is_super_admin
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-md-4",
              staticStyle: { "margin-bottom": "5px" }
            },
            [
              _c("label", [_vm._v("Filter by User/Author")]),
              _vm._v(" "),
              _c("vx_select", {
                attrs: {
                  remote_options: true,
                  remote_url: "/search/get_users",
                  placeholder: "User"
                },
                model: {
                  value: _vm.user_id,
                  callback: function($$v) {
                    _vm.user_id = $$v
                  },
                  expression: "user_id"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "paper_no_shw col-md-12",
        staticStyle: { "margin-bottom": "15px" }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-4 col-xs-12 col-sm-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "exampleInputEmail1" } }, [
                _vm._v("Company Name")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.company_name,
                    expression: "company_name"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.company_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.company_name = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-lg-1 col-xs-12 col-sm-1",
              staticStyle: { "margin-top": "15px" }
            },
            [
              _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.search } },
                [_vm._v("Search")]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "project box col-md-12",
      staticStyle: { "margin-bottom": "15px" },
      attrs: { id: "example-table" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }